import React, { useCallback, useEffect, useRef } from "react";
import SnackChip from "../SnackChip/SnackChip";
import {
  getLocalTranslation,
  useComponentVisibles,
} from "../../utils/functions";
import { ITableButtonOption } from "../Table/Table";
import EditSvg from "../../assets/img/edit.svg";
import { PopulatedTemplate } from "../../models/SurveyModels";
import { useTranslation } from "react-i18next";
import { ITemplateButtonOptions } from "../../pages/Survey/Template/TemplatePage";
import images, { getImage, getTemplateImg } from "../../assets/img/template";
import getClasses from "../../utils/getClasses";

require("./CardTemplate.scss");

interface ICardTemplate {
  buttonsOption: Array<ITemplateButtonOptions>;
  templates: PopulatedTemplate[];
}

export const CardTemplate = ({ buttonsOption, templates }: ICardTemplate) => {
  const refs = useRef<(HTMLDivElement | null)[]>([]);

  const handleRefAssignment =
    (index: number) => (ref: HTMLDivElement | null) => {
      refs.current[index] = ref;
    };

  const { isComponentVisible, setComponentVisible } = useComponentVisibles(
    false,
    refs
  );

  const { t } = useTranslation();
  const optionsButton = (indexData: number) => {
    const handleOptionClick = (optionIndex: number) => {
      const option = buttonsOption && buttonsOption[indexData][optionIndex];
      if (option && option.onClick) {
        setComponentVisible(indexData);
        option.onClick(indexData);
      }
    };
    return (
      <div
        key={indexData}
        className="table-options-menu"
        ref={handleRefAssignment(indexData)}
      >
        <div className="container-wrapper-options">
          <div
            className="wrapper-options"
            onClick={() => {
              setComponentVisible(indexData);
            }}
          >
            <img src={EditSvg} alt="edit"></img>
          </div>
          <div
            className={`container-options ${
              isComponentVisible[indexData] ? "open" : ""
            }`}
          >
            {isComponentVisible[indexData] &&
              buttonsOption![indexData].map(
                ({ label, onClick, colorTheme, icon, isLoading }, index) => (
                  <div className="item-options " key={index}>
                    <div
                      key={index}
                      onClick={() => {
                        handleOptionClick(index);
                      }}
                      className={`menu-item menu-item-${colorTheme}`}
                    >
                      <span
                        className={`icon  icon-button-table color-${colorTheme}`}
                      >
                        {icon}
                      </span>
                      <span
                        className={`capitalize-first-letter color-${colorTheme}`}
                      >
                        {label}
                      </span>
                    </div>
                  </div>
                )
              )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {templates.map((template, index) => {
        return (
          <div
            key={template.id}
            className=" col-lg-4 col-xl-3 card-template-container"
          >
            <div className="card-wrapper">
              <div className="wrapper-info">
                <div className="container-image">
                  <img
                    alt={template?.image}
                    className="img-template"
                    src={getTemplateImg(template?.image)}
                  ></img>
                </div>
                <div className="info-template">
                  <div className="template-name">
                    {template.translations &&
                      getLocalTranslation(template.translations).name}
                  </div>
                  <div className="template-sescription">
                    {template.translations &&
                      getLocalTranslation(template.translations).description}
                  </div>
                </div>
              </div>
              <div className="template-footer">
                <span className="template-number-questions">
                  {template.questions?.length}{" "}
                  {t(
                    `home.survey.questions.${
                      template.questions?.length === 1 ? "single" : "title"
                    }`
                  )}
                </span>
                {template.status !== "ACTIVE" && (
                  <div>
                    <SnackChip
                      theme={
                        template.status === "ARCHIVED" ? "disabled" : "draft"
                      }
                      borderRadius="sm"
                      label={t(`home.template.status.${template.status}`)}
                    />
                  </div>
                )}
                <>{optionsButton(index)}</>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
